import { Spotlight as AkSpotlight } from '@atlaskit/onboarding';
import type { SpotlightProps } from '@atlaskit/onboarding/types';

import { wrapComponentForChoreographer } from '../utils';

export const Spotlight = wrapComponentForChoreographer<SpotlightProps>(AkSpotlight);
